<div class="content-container mt-3">
  <div class="container p-0">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="d-flex flex-column mt-3">
        <div>
          <button
            type="button"
            class="btn-close align-self-end pe-3"
            aria-label="Close"
            (click)="activeModal.dismiss()"
          >
          </button>
          <h3 class="ps-3">Transfer of keepership completed</h3>
        </div>
        <hr class="horizontal-line" />
        <div class="mt-3 px-3">
          <p><strong>Congratulations on Your New Friend!</strong></p>
          <p>
            You’ve successfully completed the transfer of keepership. Your new furry friend is now
            officially part of your account!
          </p>

          <p>
            To make the most of your pet's journey, check out our memberships and products designed
            to keep them happy and healthy. Click the button below to explore what we offer.
          </p>
        </div>
      </div>
      <hr class="horizontal-line" />
      <button
        class="btn btn-secondary text-white btn-lg mt-3 mb-5 align-self-end me-4 modal-button"
        (click)="activeModal.dismiss()"
      >
        <img
          width="28"
          src="assets/images/identibase/whitepawlarge.png"
          class="modal-button-image"
          alt="whitepawlarge"
        />
        Explore
      </button>
    </div>
  </div>
</div>
